import { getRequest, postRequest } from 'src/services/requests';
import { getItemLocalStorage } from '@cigam/template/dist/utils/getItemLocalStorage';
import { portalDeAcesso } from 'src/utils/portalAcesso';
import {
  ParametrosPortaisDTO,
  ParametrosPortaisRetornoDTO,
} from '../types/dtos/genericos';

const getDadosPerfil = (): ParametrosPortaisRetornoDTO | null =>
  JSON.parse(localStorage.getItem('perfil') || '');

const buscarPerfil = (): void => {
  const path = window.location.pathname.split('/');
  const portais = path[1].includes('portal')
    ? `${path[1]}`
    : getItemLocalStorage('settings').defaultPortal ||
      getItemLocalStorage('settings').activePortals[0];
  const parametrosPortais = new Promise<ParametrosPortaisRetornoDTO>(
    (resolve, reject) => {
      getRequest(
        `genericos/ge/parametrosportal/BuscarPerfil?Tipo=${portalDeAcesso(
          portais
        )}`,
        resolve,
        reject
      );
    }
  );
  parametrosPortais.then(response => {
    localStorage.setItem('perfil', JSON.stringify(response));
  });
};

const buscarValor = (
  Parametros: ParametrosPortaisDTO
): Promise<ParametrosPortaisRetornoDTO[]> => {
  return new Promise((resolve, reject) => {
    postRequest(
      '/genericos/ge/parametrosportal/BuscarValor',
      Parametros,
      resolve,
      reject
    );
  });
};

export { getDadosPerfil, buscarPerfil, buscarValor };
